import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import {
  BET_TYPES_VIEW,
  COLOR_BY_WIN_TYPE,
  ROUND_WIN_TYPE_VIEW,
  WIN_TYPE_NAME,
} from '../../../enums/betTypesEnum';

export const BetShopResults = observer(
  ({ winBetTypes, memoWinBetTypes, winBetTypesIds, resultsContainer }) => {
    const t = useTranslation();

    const winMarketsCounts = useMemo(() => {
      return winBetTypes?.reduce(
        (acc, cur) => {
          if (cur?.roundData) {
            if (cur.roundData.winType === BET_TYPES_VIEW.TIE) {
              acc.tieCount += 1;
            } else if (cur?.roundData.winType === BET_TYPES_VIEW.PLAYER) {
              if (cur?.roundData.isPairWin) {
                acc.playerWinWithPairCount += 1;
              }
              acc.playerWinCount += 1;
            } else {
              if (cur?.roundData.isPairWin) {
                acc.bankerWinWithPairCount += 1;
              }
              acc.bankerWinCount += 1;
            }
          }
          return acc;
        },
        {
          roundNumberAfterShuffle: winBetTypes.length,
          bankerWinCount: 0,
          bankerWinWithPairCount: 0,
          playerWinCount: 0,
          playerWinWithPairCount: 0,
          tieCount: 0,
        }
      );
    }, [winBetTypes]);

    return (
      <div className='bb-bet-section-left-col'>
        <div className='bb-round-info'>
          <p className='bb-round-info-txt'>
            <span className='bb-round-info-txt-num'>
              {winMarketsCounts?.roundNumberAfterShuffle}
            </span>
            <span className='bb-round-info-txt-wrp'>{t('ROUNDS')}</span>
          </p>
          <div className='bb-round-info-row'>
            <div className='bb-round-info-col'>
              <div className='bb-chip blue type-1 lg'>P</div>
              <span className='bb-round-info-num'>{winMarketsCounts?.playerWinCount}</span>
            </div>
            <div className='bb-round-info-col'>
              <div className='bb-chip red type-1 lg'>B</div>
              <span className='bb-round-info-num'>{winMarketsCounts?.bankerWinCount}</span>
            </div>
            <div className='bb-round-info-col'>
              <div className='bb-chip green type-1 lg'>T</div>
              <span className='bb-round-info-num'>{winMarketsCounts?.tieCount}</span>
            </div>
          </div>
        </div>
        <div className='bb-bet-left-section-items'>
          <div className='bb-bet-left-section-items-inside' ref={resultsContainer}>
            {memoWinBetTypes.map((item, index) => {
              if (item?.roundData) {
                return (
                  <div key={winBetTypesIds[index]} className='bb-bet-left-section-item'>
                    <div
                      className={`bb-chip ${
                        COLOR_BY_WIN_TYPE[ROUND_WIN_TYPE_VIEW[item?.roundData?.winType]]
                      } type-1 xl`}
                    >
                      {WIN_TYPE_NAME[item?.roundData?.winType]}
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
      </div>
    );
  }
);
